import React from 'react';

const WorkProcess = () => (
  <section id="work-process" className="work-process section">
    <div className="container section-title">
      <h2>Kenali Tahapan Belajar di Bimbel Kedinasan Kami</h2>
      <div>
        <span>STEMA</span> <span className="description-title">KUPANG</span>
      </div>
    </div>
    <div className="container">
      <div className="row">
        <div className="col-lg-6">
          <div className="steps-content">
            <h2>Tahapan Belajar Kedinasan yang Terstruktur</h2>
            <p className="lead">
              Kami merancang tahapan belajar yang efektif dan terarah untuk membantu siswa lolos seleksi sekolah kedinasan terbaik.
            </p>
            <p>Dari tes awal hingga pendampingan akhir, seluruh proses dilakukan dengan pendekatan personal dan latihan intensif berbasis CAT.</p>
            <div className="steps-cta">
              <a href="#consultation" className="btn btn-primary">Daftar Sekarang</a>
              <a href="#team" className="btn btn-outline">Lihat Program</a>
            </div>
          </div>
        </div>
        <div className="col-lg-6">
          <div className="steps-list">
            <div className="step-item">
              <div className="step-number">01</div>
              <div className="step-content">
                <h3>Pendaftaran & Tes Diagnostik</h3>
                <p>Peserta mengisi formulir dan mengikuti tes awal untuk memetakan kemampuan dasar sebagai acuan penyusunan strategi belajar.</p>
              </div>
            </div>
            <div className="step-item">
              <div className="step-number">02</div>
              <div className="step-content">
                <h3>Penjadwalan & Pembentukan Kelas</h3>
                <p>Peserta dibagi dalam kelas sesuai kemampuan. Jadwal intensif disusun untuk fokus pada TKP, TIU, dan TWK.</p>
              </div>
            </div>
            <div className="step-item">
              <div className="step-number">03</div>
              <div className="step-content">
                <h3>Kelas Intensif & Latihan Soal</h3>
                <p>Pembelajaran aktif dengan tutor profesional disertai latihan soal harian dan pembahasan mendalam.</p>
              </div>
            </div>
            <div className="step-item">
              <div className="step-number">04</div>
              <div className="step-content">
                <h3>Try Out & Evaluasi Berkala</h3>
                <p>Simulasi CAT dilakukan secara rutin. Hasil evaluasi digunakan untuk memperbaiki kelemahan peserta.</p>
              </div>
            </div>
            <div className="step-item">
              <div className="step-number">05</div>
              <div className="step-content">
                <h3>Pendampingan & Pembekalan Final</h3>
                <p>Menjelang seleksi, peserta dibekali mental, strategi, dan motivasi. Pendampingan berlanjut hingga pengumuman kelulusan.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default WorkProcess;
